module.exports = __webpack_public_path__ + "img/fruit-pummelo-190x100.c6878d2e.jpg";